import Splide from '@splidejs/splide';

class Slider {
  constructor() {
    this.spliteOptions = {
      autoplay: false,
      autoHeight: false,
      autoWidth: false,
      arrows: true,
      clones: 0,
      interval: 5_000,
      keyboard: true,
      lazyLoad: 'nearby',
      pagination: true,
      pauseOnFocus: true,
      pauseOnHover: true,
      perMove: 1,
      reducedMotion: {
        autoplay: false,
      },
      resetProgress: false,
      rewind: true,
      rewindSpeed: 500,
      type: 'loop',
      speed: 500,
      classes: {
        pagination: 'splide__pagination c-slider__pagination',
        page: 'splide__pagination__page c-slider__page',
      },
    };
    this.splideEl = document.querySelectorAll('[data-slider]');

    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    this.splideEl.forEach(el => {
      new Splide(el, this.spliteOptions).mount();
    })
  }
}
export default new Slider();

